import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '../Typography'; // Adjust path as needed
import './InsuranceVerificationDetails.scss';

type SessionLimitProps = {
  annualLimit: number | string;
  remaining: number | string;
  className?: string;
};

export const InsuranceSessionLimit: React.FC<SessionLimitProps> = ({
  annualLimit,
  remaining,
  className,
}) => {
  const { t } = useTranslation('insuranceVerification');

  return (
    <div className={`card-container ${className || ''}`}>
      <Typography variant="size-20" color="color-2">
        {t('insuranceSessionLimit.title')}
      </Typography>
      <div className="d-flex justify-content-between align-items-center mt-3">
        <div className="">
          <Typography
            variant="size-10"
            weight="bold"
            color="color-28"
            className="mt-3"
            textTransform="uppercase"
          >
            {t('insuranceSessionLimit.annualVisitLimitLabel')}
          </Typography>
          <Typography
            variant="size-26"
            weight="bold"
            color="color-2"
            className="mt-1"
          >
            {annualLimit}{' '}
            <Typography
              component="span"
              variant="size-10"
              weight="bold"
              color="color-2"
              className="mt-3"
              textTransform="uppercase"
            >
              {t('insuranceSessionLimit.sessionsPerYear')}
            </Typography>
          </Typography>
        </div>
        <div>
          <Typography
            variant="size-10"
            weight="bold"
            color="color-28"
            className="mt-3"
            textTransform="uppercase"
          >
            {t('insuranceSessionLimit.visitsRemainingLabel')}
          </Typography>
          <Typography
            variant="size-26"
            weight="bold"
            color="color-2"
            className="mt-1"
          >
            {remaining}{' '}
            <Typography
              component="span"
              variant="size-10"
              weight="bold"
              color="color-2"
              className="mt-3"
              textTransform="uppercase"
            >
              {t('insuranceSessionLimit.sessions')}
            </Typography>
          </Typography>
        </div>
      </div>
      <Typography variant="size-14" color="color-28" className="mt-2">
        {t('insuranceSessionLimit.description')}
      </Typography>
    </div>
  );
};
